import { useDrag } from 'react-dnd';
import { useContextMenu } from 'react-contexify';

type DraggableAttributeProps = {
  name: string;
  variableKey?: string;
  id: string;
  type: string;
  disabled?: boolean;
  resourceType?: string;
  allowedZoneTypes?: string[];
  tooltipId?: string;
  tooltipContent?: string;
};

export default function DraggableAttribute({
  name,
  variableKey,
  id,
  type,
  disabled,
  resourceType,
  allowedZoneTypes,
  tooltipId,
  tooltipContent,
}: DraggableAttributeProps) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: type,
      item: { name, id, resourceType, allowedZoneTypes, key: variableKey },
      canDrag: () => !disabled,
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [disabled, name, id, type, resourceType, allowedZoneTypes, variableKey]
  );

  const { show } = useContextMenu({
    id: type,
  });

  return (
    <div
      className={`px-1 py-0.5 ${
        disabled
          ? ''
          : 'cursor-move  hover:border-l-2 hover:border-gray-400 hover:-ml-0.5'
      } ${isDragging ? 'opacity-50' : ''} ${
        disabled ? 'select-none opacity-50' : ''
      }`}
      ref={drag}
      onContextMenu={(e) =>
        show(e, {
          props: {
            id,
            name,
            type,
            resourceType,
            allowedZoneTypes,
            key: variableKey,
            // ATAD-146: the right-click menu still opens on an item that
            // can't be dragged; its handlers decide what that means.
            disabled,
          },
        })
      }
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
    >
      {name}
    </div>
  );
}
